import { Injectable } from '@angular/core';
import { PermissionDataModel } from '@osos/shared/api';
import { AccessRightLevelEnum } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

import { PermissionsPresenterModel } from '@osos/shared/types';

@Injectable()
export class PermissionsParserV1Service extends ParserBase<
  PermissionDataModel,
  PermissionsPresenterModel
> {
  nonePermission = {
    value: { level: AccessRightLevelEnum.None },
  };
  constructor() {
    super(PermissionDataModel, PermissionsPresenterModel, 1);
  }

  getPresenterModel(model: PermissionDataModel): PermissionsPresenterModel {
    return {
      specificationVersion: this.version,
      permission: model.permission ?? this.nonePermission,

      parentPermission: model?.['parentPermission'] ?? this.nonePermission,
      id: model.id,
      state: model.state,
      value: model.value,
    } as PermissionsPresenterModel;
  }
  getDataModel(presenter: PermissionsPresenterModel): PermissionDataModel {
    return {
      specificationVersion: this.version,
      permission: presenter.permission,
      id: presenter.id,
      state: presenter.state,
      value: presenter.value,
      dataEntity: presenter.dataEntity,
      isInvalid: false,
    } as PermissionDataModel;
  }
}
